export default __webpack_public_path__ + "static/media/13.cdcbfd85.png";